var path = '/templates/core/views/admin.html';
var html = "<div class=all-filter loading><div id=loader></div></div><div id=wrapper><header class=\"navbar navbar-inverse\" role=banner><div ui-view=header></div></header><div ui-view=mainnav></div><div ui-view=content></div></div><zc-footer></zc-footer>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../app_shared/src/shared_modules/core/views/admin.html
// module id = 1286
// module chunks = 0